import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";

// ─── Colour tokens ───────────────────────────────────────────────────────────
const NAVY = "#1a237e";
const NAVY_LIGHT = "#e8eaf6";

// ─── All match data extracted from the screenshots ───────────────────────────
const DIVISIONS = {
  A: {
    label: "DIVISION A",
    description:
      "4-pool with Quarter-final, Semi-final & Finals 11th & 12th ranked teams to be relegated to Division 'B'",
    pools: {
      "Pool A": [
        {
          matchNo: "Match 29",
          date: "5 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division A",
          teamA: "HOCKEY JHARKHAND",
          teamB: "DADRA & NAGAR HAVELI AND DAMAN & DIU HOCKEY",
        },
        {
          matchNo: "Match 37",
          date: "6 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division A",
          teamA: "HOCKEY PUNJAB",
          teamB: "HOCKEY CHANDIGARH",
        },
        {
          matchNo: "Match 41",
          date: "7 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division A",
          teamA: "HOCKEY CHANDIGARH",
          teamB: "HOCKEY MAHARASHTRA",
        },
      ],
      "Pool B": [
        {
          matchNo: "Match 30",
          date: "5 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division A",
          teamA: "HOCKEY JHARKHAND",
          teamB: "HOCKEY UNIT OF TAMIL NADU",
        },
        {
          matchNo: "Match 38",
          date: "6 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division A",
          teamA: "HOCKEY JHARKHAND",
          teamB: "DADRA & NAGAR HAVELI AND DAMAN & DIU HOCKEY",
        },
        {
          matchNo: "Match 42",
          date: "7 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division A",
          teamA: "DADRA & NAGAR HAVELI AND DAMAN & DIU HOCKEY",
          teamB: "HOCKEY UNIT OF TAMIL NADU",
        },
      ],
      "Pool C": [
        {
          matchNo: "Match 31",
          date: "5 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 1",
          pool: "Pool C | Division A",
          teamA: "UTTAR PRADESH HOCKEY",
          teamB: "MANIPUR HOCKEY",
        },
        {
          matchNo: "Match 39",
          date: "6 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 1",
          pool: "Pool C | Division A",
          teamA: "UTTAR PRADESH HOCKEY",
          teamB: "HOCKEY HARYANA",
        },
        {
          matchNo: "Match 43",
          date: "7 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 1",
          pool: "Pool C | Division A",
          teamA: "HOCKEY HARYANA",
          teamB: "MANIPUR HOCKEY",
        },
      ],
      "Pool D": [
        {
          matchNo: "Match 32",
          date: "5 April, 2026",
          time: "16:00 PM IST",
          pitch: "Pitch 1",
          pool: "Pool D | Division A",
          teamA: "HOCKEY MADHYA PRADESH",
          teamB: "KERALA HOCKEY",
        },
        {
          matchNo: "Match 40",
          date: "6 April, 2026",
          time: "16:00 PM IST",
          pitch: "Pitch 1",
          pool: "Pool D | Division A",
          teamA: "HOCKEY MADHYA PRADESH",
          teamB: "HOCKEY ASSOCIATION OF ODISHA",
        },
        {
          matchNo: "Match 44",
          date: "7 April, 2026",
          time: "16:00 PM IST",
          pitch: "Pitch 1",
          pool: "Pool D | Division A",
          teamA: "HOCKEY ASSOCIATION OF ODISHA",
          teamB: "KERALA HOCKEY",
        },
      ],
    },
  },
  B: {
    label: "DIVISION B",
    description:
      "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'A' and last two ranked teams to be relegated to Division 'C'",
    pools: {
      "Pool A": [
        {
          matchNo: "Match 4",
          date: "1 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "DELHI HOCKEY",
          teamB: "TELANGANA HOCKEY",
        },
        {
          matchNo: "Match 5",
          date: "1 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "HOCKEY GUJARAT",
          teamB: "HOCKEY UTTARAKHAND",
        },
        {
          matchNo: "Match 10",
          date: "2 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "DELHI HOCKEY",
          teamB: "HOCKEY BENGAL",
        },
        {
          matchNo: "Match 11",
          date: "2 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "HOCKEY GUJARAT",
          teamB: "TELANGANA HOCKEY",
        },
        {
          matchNo: "Match 15",
          date: "3 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division B",
          teamA: "HOCKEY BENGAL",
          teamB: "HOCKEY UTTARAKHAND",
        },
        {
          matchNo: "Match 20",
          date: "4 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "DELHI HOCKEY",
          teamB: "HOCKEY GUJARAT",
        },
        {
          matchNo: "Match 21",
          date: "4 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "TELANGANA HOCKEY",
          teamB: "HOCKEY UTTARAKHAND",
        },
        {
          matchNo: "Match 24",
          date: "5 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "HOCKEY GUJARAT",
          teamB: "HOCKEY BENGAL",
        },
        {
          matchNo: "Match 30",
          date: "6 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "DELHI HOCKEY",
          teamB: "HOCKEY UTTARAKHAND",
        },
        {
          matchNo: "Match 31",
          date: "6 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 2",
          pool: "Pool A | Division B",
          teamA: "HOCKEY BENGAL",
          teamB: "TELANGANA HOCKEY",
        },
      ],
      "Pool B": [
        {
          matchNo: "Match 6",
          date: "1 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "HOCKEY KARNATAKA",
          teamB: "HOCKEY HIMACHAL",
        },
        {
          matchNo: "Match 7",
          date: "1 April, 2026",
          time: "16:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "CHHATTISGARH ARH HOCKEY",
          teamB: "BIHAR (BSSA)",
        },
        {
          matchNo: "Match 12",
          date: "2 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "HOCKEY KARNATAKA",
          teamB: "HOCKEY ARUNACHAL",
        },
        {
          matchNo: "Match 13",
          date: "2 April, 2026",
          time: "16:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "CHHATTISGARH ARH HOCKEY",
          teamB: "HOCKEY HIMACHAL",
        },
        {
          matchNo: "Match 16",
          date: "3 April, 2026",
          time: "16:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division B",
          teamA: "HOCKEY ARUNACHAL",
          teamB: "BIHAR (BSSA)",
        },
        {
          matchNo: "Match 22",
          date: "4 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "HOCKEY KARNATAKA",
          teamB: "CHHATTISGARH ARH HOCKEY",
        },
        {
          matchNo: "Match 23",
          date: "4 April, 2026",
          time: "18:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "HOCKEY HIMACHAL",
          teamB: "BIHAR (BSSA)",
        },
        {
          matchNo: "Match 25",
          date: "5 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "CHHATTISGARH ARH HOCKEY",
          teamB: "HOCKEY ARUNACHAL",
        },
        {
          matchNo: "Match 32",
          date: "6 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "HOCKEY KARNATAKA",
          teamB: "BIHAR (BSSA)",
        },
        {
          matchNo: "Match 33",
          date: "6 April, 2026",
          time: "16:00 AM IST",
          pitch: "Pitch 2",
          pool: "Pool B | Division B",
          teamA: "HOCKEY ARUNACHAL",
          teamB: "HOCKEY HIMACHAL",
        },
      ],
    },
  },
  C: {
    label: "DIVISION C",
    description:
      "2-pool with only league matches 1st & 2nd ranked teams to be promoted to Division 'B'",
    pools: {
      "Pool A": [
        {
          matchNo: "Match 1",
          date: "1 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division C",
          teamA: "HOCKEY ANDHRA PRADESH",
          teamB: "ASSAM HOCKEY",
        },
        {
          matchNo: "Match 2",
          date: "1 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division C",
          teamA: "HOCKEY MIZORAM",
          teamB: "LE PUDUCHERRY HOCKEY",
        },
        {
          matchNo: "Match 8",
          date: "2 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division C",
          teamA: "HOCKEY ANDHRA PRADESH",
          teamB: "LE PUDUCHERRY HOCKEY",
        },
        {
          matchNo: "Match 9",
          date: "2 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division C",
          teamA: "HOCKEY MIZORAM",
          teamB: "ASSAM HOCKEY",
        },
        {
          matchNo: "Match 17",
          date: "4 April, 2026",
          time: "8:45 AM IST",
          pitch: "Pitch 1",
          pool: "Pool A | Division C",
          teamA: "HOCKEY JAMMU & KASHMIR",
          teamB: "HOCKEY RAJASTHAN",
        },
      ],
      "Pool B": [
        {
          matchNo: "Match 3",
          date: "1 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division C",
          teamA: "GOANS HOCKEY",
          teamB: "HOCKEY JAMMU & KASHMIR",
        },
        {
          matchNo: "Match 14",
          date: "3 April, 2026",
          time: "7:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division C",
          teamA: "GOANS HOCKEY",
          teamB: "HOCKEY RAJASTHAN",
        },
        {
          matchNo: "Match 18",
          date: "4 April, 2026",
          time: "10:30 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division C",
          teamA: "HOCKEY ANDHRA PRADESH",
          teamB: "HOCKEY MIZORAM",
        },
        {
          matchNo: "Match 19",
          date: "4 April, 2026",
          time: "16:00 AM IST",
          pitch: "Pitch 1",
          pool: "Pool B | Division C",
          teamA: "LE PUDUCHERRY HOCKEY",
          teamB: "ASSAM HOCKEY",
        },
      ],
    },
  },
};

// ─── Single match card (matches the screenshot design) ───────────────────────
function MatchCard({ match }) {
  return (
    <div
      style={{
        background: "#fff",
        border: "1.5px solid #e0e3f0",
        borderRadius: "12px",
        padding: "16px 18px 10px",
        marginBottom: "12px",
      }}
    >
      {/* Teams row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
        }}
      >
        {/* Team A */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flex: 1,
          }}
        >
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: NAVY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" />
            </svg>
          </div>
          <span
            style={{
              fontWeight: 600,
              fontSize: "12px",
              color: NAVY,
              textTransform: "uppercase",
              lineHeight: 1.2,
            }}
          >
            {match.teamA}
          </span>
        </div>

        {/* VS */}
        <span
          style={{
            fontWeight: 900,
            fontSize: "15px",
            color: NAVY,
            flexShrink: 0,
            padding: "0 6px",
          }}
        >
          VS
        </span>

        {/* Team B */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flex: 1,
            justifyContent: "flex-end",
          }}
        >
          <span
            style={{
              fontWeight: 600,
              fontSize: "12px",
              color: NAVY,
              textTransform: "uppercase",
              lineHeight: 1.2,
              textAlign: "right",
            }}
          >
            {match.teamB}
          </span>
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: NAVY,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Meta row */}
      <div
        style={{
          marginTop: "10px",
          paddingTop: "8px",
          borderTop: "1px solid #e8eaf6",
          display: "flex",
          flexWrap: "wrap",
          gap: "14px",
          fontSize: "11px",
          color: "#555",
        }}
      >
        <span>
          <strong style={{ color: NAVY }}>{match.matchNo}</strong>
        </span>
        <span>📅 {match.date}</span>
        <span>🕐 {match.time}</span>
        <span>📍 {match.pitch}</span>
        <span>👥 {match.pool}</span>
      </div>
    </div>
  );
}

// ─── Main page component ─────────────────────────────────────────────────────
export default function SubJuniorMensHockeyMatchSchedule() {
  const divisionKeys = Object.keys(DIVISIONS);
  const [activeDivision, setActiveDivision] = useState("A");
  const [activePool, setActivePool] = useState("Pool A");

  const division = DIVISIONS[activeDivision];
  const poolKeys = Object.keys(division.pools);

  // When switching division reset pool to first available
  function handleDivision(key) {
    setActiveDivision(key);
    setActivePool(Object.keys(DIVISIONS[key].pools)[0]);
  }

  // All matches across all pools for "View All"
  const allMatches = Object.values(division.pools).flat();
  const displayMatches =
    activePool === "View All" ? allMatches : division.pools[activePool] || [];

  // 2-column grid for desktop
  const col1 = displayMatches.filter((_, i) => i % 2 === 0);
  const col2 = displayMatches.filter((_, i) => i % 2 !== 0);

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundImage: "url('/img/bghockyimg.jpeg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* ← Return */}
      <div style={{ padding: "16px 20px", textAlign: "left" }}>
        <Button
          href="/sub-junior-mens-hockey-2026"
          style={{
            backgroundColor: NAVY,
            borderColor: NAVY,
            fontSize: "12px",
            padding: "6px 16px",
          }}
        >
          ← Return
        </Button>
      </div>

      <Container style={{ maxWidth: "960px", paddingBottom: "60px" }}>
        {/* Page title */}
        <h1
          style={{
            color: NAVY,
            fontWeight: 900,
            fontSize: "clamp(22px, 4vw, 36px)",
            textAlign: "center",
            textTransform: "uppercase",
            letterSpacing: "1px",
            marginBottom: "28px",
          }}
        >
          Match Schedule
        </h1>

        {/* Division tabs */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "24px",
            flexWrap: "wrap",
          }}
        >
          {divisionKeys.map((key) => (
            <button
              key={key}
              onClick={() => handleDivision(key)}
              style={{
                padding: "10px 28px",
                borderRadius: "8px",
                border: `2px solid ${NAVY}`,
                background: activeDivision === key ? NAVY : "transparent",
                color: activeDivision === key ? "#fff" : NAVY,
                fontWeight: 700,
                fontSize: "14px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              {DIVISIONS[key].label}
            </button>
          ))}
        </div>

        {/* Division heading + description */}
        <div style={{ textAlign: "center", marginBottom: "20px" }}>
          <h2
            style={{
              color: NAVY,
              fontWeight: 600,
              fontSize: "clamp(18px, 3vw, 26px)",
              textTransform: "uppercase",
            }}
          >
            {division.label}
          </h2>
          <p
            style={{
              color: NAVY,
              fontSize: "16px",
              maxWidth: "680px",
              fontWeight: 600,
              margin: "6px auto 0",
            }}
          >
            {division.description}
          </p>
        </div>

        {/* Pool filter pills */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            marginBottom: "24px",
          }}
        >
          {[...poolKeys, "View All"].map((pool) => (
            <button
              key={pool}
              onClick={() => setActivePool(pool)}
              style={{
                padding: "7px 18px",
                borderRadius: "20px",
                border: `1.5px solid ${NAVY}`,
                background: activePool === pool ? NAVY : "transparent",
                color: activePool === pool ? "#fff" : NAVY,
                fontWeight: 600,
                fontSize: "12px",
                cursor: "pointer",
                transition: "all 0.2s",
              }}
            >
              {pool}
            </button>
          ))}
        </div>

        {/* Match cards — 2-column grid on md+, 1-column on mobile */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              "repeat(auto-fill, minmax(min(100%, 420px), 1fr))",
            gap: "0 16px",
          }}
        >
          {/* interleave col1 + col2 so they visually appear side-by-side */}
          {displayMatches.map((match, i) => (
            <MatchCard key={match.matchNo + i} match={match} />
          ))}
        </div>

        {displayMatches.length === 0 && (
          <p style={{ textAlign: "center", color: NAVY, marginTop: "40px" }}>
            No matches found for this selection.
          </p>
        )}
      </Container>
    </div>
  );
}
